import { useRootService } from '@kaokei/use-vue-service';
import { UserService } from '~/services/user.service';

function handleLogin(event: any) {
  const userService = useRootService(UserService);
  if (!userService.isLogin()) {
    event.preventDefault();
    event.stopImmediatePropagation();
    userService.showLoginModal();
  }
}

export default {
  mounted(el: any, binding: any) {
    const value = binding.value ?? true;
    if (value) {
      el.addEventListener('click', handleLogin, true);
    }
  },

  unmounted(el: any, binding: any) {
    const value = binding.value ?? true;
    if (value) {
      el.removeEventListener('click', handleLogin, true);
    }
  },
};
